import styled, { css } from 'styled-components';
import { ifProp } from 'styled-tools';
import { ProductiveHeading07 } from 'components/styles';
import { TimesheetBaseTable } from './timesheet-table';

const {
  Summary: { Row, Cell },
} = TimesheetBaseTable;

export const TimesheetReportSummaryRow = styled(Row)`
  .ant-table-summary tr td {
    background: var(--coolest-gray-20);
  }
`;
export const TimesheetReportSummaryCell = styled(Cell)<{ fixed?: boolean }>`
  background: var(--coolest-gray-20);
  ${ProductiveHeading07};
  padding: calc(var(--spacing-03) - 1px) var(--spacing-05);
  border: 0;
  ${ifProp(
    'fixed',
    css`
      position: sticky;
      left: 0;
      z-index: 2;
    `,
  )};
`;

export const TimesheetReportTable = styled(TimesheetBaseTable)`
  .ant-table .ant-table-container::before,
  .ant-table .ant-table-container::after {
    z-index: 2;
  }
  .ant-table-body {
    overflow: auto !important;
    height: 100vh;
  }
  .ant-table-empty .ant-table-body {
    height: unset;
  }
  .ant-table-placeholder {
    display: none;
  }
  .ant-table-summary {
    position: sticky;
    bottom: 0;
    z-index: 2;
  }
  td.ant-table-column-sort {
    background: var(--white-100);
    border-right: 1px solid var(--table-border-color);
  }
`;
